import { render, staticRenderFns } from "./paymentagreement.vue?vue&type=template&id=0b8fc2b4&scoped=true&"
import script from "./paymentagreement.vue?vue&type=script&lang=js&"
export * from "./paymentagreement.vue?vue&type=script&lang=js&"
import style0 from "./paymentagreement.vue?vue&type=style&index=0&id=0b8fc2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8fc2b4",
  null
  
)

export default component.exports